import { useCallback } from 'react';
import useCommittedRef from './useCommittedRef';
export default function useEventCallback(fn) {
  const ref = useCommittedRef(fn);
  return useCallback(function () {
    return ref.current && ref.current(...arguments);
  }, [ref]);
}